<template>
  <div class="duo-callback">
    <v-progress-circular indeterminate color="primary" size="50" width="5" />
    <div class="status-text">Completing Duo login...</div>
  </div>
</template>

<script>
import Firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "Callback",
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const duoCode = urlParams.get("duo_code");
    const state = urlParams.get("state");

    if (!duoCode || !state) {
      console.warn("[DUO CALLBACK] Missing duo_code or state. Params:", Object.fromEntries(urlParams.entries()));
      if (this.$route.path !== "/login") this.$router.replace("/login");
      return;
    }

    const user = await this.waitForUser();
    if (!user) {
      console.error("[DUO CALLBACK] Firebase user not available.");
      if (this.$route.path !== "/login") this.$router.replace("/login");
      return;
    }

    try {
      console.log("[DUO CALLBACK] Duo login redirect succeeded. Routing to /home");

      this.$store.commit("setMfaVerified", true);

      if (this.$route.path !== "/home") {
        await this.$router.replace("/home");
      }
    } catch (err) {
      console.error("[DUO CALLBACK] Unexpected error:", err);
      if (this.$route.path !== "/login") this.$router.replace("/login");
    }
  },

  methods: {
    waitForUser(timeout = 5000) {
      return new Promise((resolve) => {
        const start = Date.now();
        const check = () => {
          const user = Firebase.auth().currentUser;
          if (user) return resolve(user);
          if (Date.now() - start > timeout) return resolve(null);
          setTimeout(check, 100);
        };
        check();
      });
    }
  }
};
</script>

<style scoped>
.duo-callback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.status-text {
  margin-top: 16px;
  color: #555;
  font-size: 16px;
}
</style>
